import AbstractOptionsModal from 'components/pages/login/layout/AbstractOptionsModal';
import { AppData } from '@lightningjs/sdk';
import { translate } from 'support/translate';
import { getFontFaceFromStyle } from 'support/textUtils';
import { LoginFlow } from '../layout/AbstractLoginModal';

const SIGN_OUT_HEADING_FONT_SIZE = 63;
const SIGN_OUT_SUB_HEADING_FONT_SIZE = 42;
const SIGN_OUT_BUTTON_FONT_SIZE = 29;
const SIGN_OUT_BUTTON_WIDTH = 350;
const SIGN_OUT_CONTENT_WIDTH = 1117;
const MODAL_WIDTH = 1920;
const MODAL_HEIGHT = 1080;
const CONTENT_HEIGHT = 675;
const SIGN_OUT_CONTENT_X = (MODAL_WIDTH - SIGN_OUT_CONTENT_WIDTH) / 2;
const SIGN_OUT_CONTENT_Y = (MODAL_HEIGHT - CONTENT_HEIGHT) / 2;
const HEADING_SUB_HEADING_GAP = 24;
const SUB_HEADING_BUTTON_GAP = 90;
const BUTTON_SPACING = 48;

export default class SignOutModal extends AbstractOptionsModal {
  override _showBackButton = false;
  override _showSkipButton = false;
  protected static override _optionsListDirection: 'row' | 'column' = 'row';
  protected static override _subHeadingWidth = SIGN_OUT_CONTENT_WIDTH;

  override get loginFlow() {
    return LoginFlow.SIGN_OUT;
  }

  private _onConfirm: (() => void) | null = null;

  override _init() {
    super._init();
    this.checkmarkIconVisible = false;
    this.headingText = translate('account.signOut.heading');
    this.subHeadingText = translate('account.signOut.subHeading');

    this._InnerContent.patch({
      x: SIGN_OUT_CONTENT_X,
      y: SIGN_OUT_CONTENT_Y,
      w: SIGN_OUT_CONTENT_WIDTH,
    });

    this._Heading.patch({
      flexItem: {
        marginBottom: HEADING_SUB_HEADING_GAP,
      },
    });
    this._HeaderText.patch({
      text: {
        fontSize: SIGN_OUT_HEADING_FONT_SIZE,
        fontFace: getFontFaceFromStyle('bold'),
        fontWeight: 700,
      },
    });

    this._SubHeading.patch({
      flexItem: {
        marginBottom: SUB_HEADING_BUTTON_GAP,
      },
      text: {
        fontSize: SIGN_OUT_SUB_HEADING_FONT_SIZE,
        fontFace: getFontFaceFromStyle('regular'),
        fontWeight: 400,
        lineHeight: 67,
      },
    });

    this._OptionsList.spacing = BUTTON_SPACING;

    this.optionItems = [
      {
        label: translate('account.signOut.cancel'),
        action: '$cancel',
        passSignals: { $cancel: '$cancel' },
        fontSize: SIGN_OUT_BUTTON_FONT_SIZE,
        minWidth: SIGN_OUT_BUTTON_WIDTH,
      },
      {
        label: translate('account.signOut.confirm'),
        action: '$confirmSignOut',
        passSignals: { $confirmSignOut: '$confirmSignOut' },
        fontSize: SIGN_OUT_BUTTON_FONT_SIZE,
        minWidth: SIGN_OUT_BUTTON_WIDTH,
      },
    ];
    this.optionSignals = {
      $cancel: '$cancel',
      $confirmSignOut: '$confirmSignOut',
    };
  }

  modalInit(data: { onConfirm?: () => void }) {
    this._onConfirm = data.onConfirm ?? null;
  }

  private $cancel() {
    AppData?.modalService.close();
  }

  private $confirmSignOut() {
    AppData?.modalService.close();
    this._onConfirm?.();
  }
}
